export const CTA_BLOCK_s2 = {
  "blockType": "CTA",
  "blockDesign": "CTADesign1",
  "editFormName": "CTA_01_FORM",
  "styleProps": {
    "background-color": "#121212",
    "padding": "120px 20px 120px 20px"
  },
  "headings": [
    {
      "text": "READY TO TRANSFORM YOUR BUSINESS WITH INNOVATIVE SOFTWARE SOLUTIONS?",
      "styleProps": {
        "text-align": "center",
        "font-size": "4.5rem",
        "line-height": "1",
        "padding": "50px 0px 30px 0px",
        "color": "#FBFBFB",
        "font-family-cust": "",
        "font-family": "'Roboto Condensed', sans-serif",
        "font-family-bk": "'Roboto Condensed', sans-serif",
        "font-weight": "900"
      },
      "alignStyleProps": {
        "text-align": "center"
      },
      "stylePropsTab": {
        "font-size": "3rem",
        "line-height": "1"
      },
      "stylePropsMob": {
        "font-size": "2.25rem",
        "line-height": "2.5rem"
      }
    }
  ],
  "showBtnSec": true,
  "btnSecStyleProps": {},
  "btnSecStylePropsTab": {},
  "btnSecStylePropsMob": {},
  "buttons": [
    {
      "text": "➤  Get Started",
      "alt": "Click Here",
      "href": "https://yahoo.com",
      "styleProps": {
        "background-color": "#383838",
        "color": "#ffffff",
        "border-color": "#3b82f680",
        "border-radius": "1rem",
        "padding": "14px 40px 14px 40px",
        "border-width": "0px"
      },
      "openType": "sametab"
    }
  ],
  "showEmailSec": true,
  "emailSecStyleProps": {},
  "subscription": {
    "showSection": "hide",
    "display": "enable",
    "subConfigs": {
      "configType": "convertkit",
      "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
      "configPlaceholder": ""
    },
    "email_placeholder": {
      "text": "example@mail.com"
    },
    "buttonText": {
      "text": "Subscribe",
      "styleProps": {
        "background-color": "#1b1b31",
        "color": "#ffffff"
      }
    },
    "successMessage": {
      "text": "Thank you for the signup",
      "styleProps": {}
    },
    "errorMessage": {
      "text": "Something went wrong. Please try again.",
      "styleProps": {}
    }
  },
  "metaDataId": 1746187487658,
  "afterIndex": 7,
  "blockId": 1746187487658,
  "containerStyleProps": {
    "padding": "0px 0px 0px 00px",
    "max-width": "1024px"
  },
  "containerStylePropsTab": {
    "padding": "0px 0px 0px 0px"
  },
  "fonts": {
    "headings": [
      ""
    ]
  },
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  }
}